module.exports = __webpack_public_path__ + "static/media/mrshakeshop.9335013e.jpg";